export class MasterFastagReconciliation {
  OPERATION_NUMBER: number;
  REMARK: string;
}
